import { createFileRoute, Link } from '@tanstack/react-router';
import { ArrowLeft } from 'lucide-react';
import { sectionByKey } from '../../lib/sections';
import { NegociosPage, CatalogoPage, TarjetasPage } from '@/domains/retail';
import { VentasPage } from '@/domains/retail/ventas/VentasPage';

function SectionScreen() {
    const { key } = Route.useParams();
    // Secciones ya construidas de F1 → pantalla real. El resto sigue en placeholder.
    if (key === 'ventas') return <VentasPage />;
    if (key === 'operacion-retail') return <NegociosPage />;
    if (key === 'catalogo') return <CatalogoPage />;
    if (key === 'tarjetas-pcf') return <TarjetasPage />;
    return <SectionPlaceholder />;
}

function SectionPlaceholder() {
    const { key } = Route.useParams();
    const section = sectionByKey(key);

    return (
        <div className="space-y-6">
            <Link
                to="/"
                className="inline-flex items-center gap-1.5 text-sm font-medium text-slate-500 hover:text-primary"
            >
                <ArrowLeft className="h-4 w-4" aria-hidden />
                Inicio
            </Link>

            <div className="flex flex-col items-center justify-center rounded-xl border border-dashed border-slate-300 bg-white py-20 text-center">
                {section ? (
                    <span className="mb-4 inline-flex h-14 w-14 items-center justify-center rounded-2xl bg-primary/10 text-primary">
                        <section.icon className="h-7 w-7" aria-hidden />
                    </span>
                ) : null}
                <h1 className="text-xl font-bold tracking-tight">{section?.label ?? 'Sección'}</h1>
                <p className="mt-1 text-sm text-slate-500">Próximamente</p>
            </div>
        </div>
    );
}

export const Route = createFileRoute('/_authenticated/_layout/seccion/$key')({
    component: SectionScreen,
});
